export default __webpack_public_path__ + "static/media/login_banner.9c0a4474.png";